export default __webpack_public_path__ + "static/media/header.3deea725.jpg";